import { defineComponent as h, ref as g, provide as b, h as m } from "vue";
import P, { popoverBaseProps as c } from "./ghl-ui.es216.js";
import _, { panelProps as O, panelPropKeys as d } from "./ghl-ui.es1073.js";
import { popselectInjectionKey as j } from "./ghl-ui.es1074.js";
import y from "./ghl-ui.es854.js";
import u from "./ghl-ui.es855.js";
import { keep as R } from "./ghl-ui.es930.js";
import { createRefSetter as $ } from "./ghl-ui.es999.js";
import { mergeEventHandlers as v } from "./ghl-ui.es1075.js";
import { omit as f } from "./ghl-ui.es1058.js";
import M from "./ghl-ui.es1076.js";
const w = Object.assign(Object.assign(Object.assign(Object.assign({}, u.props), f(c, ["showArrow", "arrow"])), {
  placement: Object.assign(Object.assign({}, c.placement), {
    default: "bottom"
  }),
  trigger: {
    type: String,
    default: "hover"
  }
}), O), E = h({
  name: "Popselect",
  props: w,
  inheritAttrs: !1,
  __popover__: !0,
  setup(n) {
    const {
      mergedClsPrefixRef: a
    } = y(n), s = u("Popselect", "-popselect", void 0, M, n, a), r = g(null);
    function i() {
      var o;
      (o = r.value) === null || o === void 0 || o.syncPosition();
    }
    function p(o) {
      var e;
      (e = r.value) === null || e === void 0 || e.setShow(o);
    }
    return b(j, {
      props: n,
      mergedThemeRef: s,
      syncPosition: i,
      setShow: p
    }), Object.assign(Object.assign({}, {
      syncPosition: i,
      setShow: p
    }), {
      popoverInstRef: r,
      mergedTheme: s
    });
  },
  render() {
    const {
      mergedTheme: n
    } = this, a = {
      theme: n.peers.Popover,
      themeOverrides: n.peerOverrides.Popover,
      builtinThemeOverrides: {
        padding: "0"
      },
      ref: "popoverInstRef",
      internalRenderBody: (s, r, i, p, l) => {
        const {
          $attrs: o
        } = this;
        return m(_, Object.assign({}, o, {
          class: [o.class, s],
          style: [o.style, ...i]
        }, R(this.$props, d), {
          ref: $(r),
          onMouseenter: v([p, o.onMouseenter]),
          onMouseleave: v([l, o.onMouseleave])
        }), {
          header: () => {
            var e, t;
            return (t = (e = this.$slots).header) === null || t === void 0 ? void 0 : t.call(e);
          },
          action: () => {
            var e, t;
            return (t = (e = this.$slots).action) === null || t === void 0 ? void 0 : t.call(e);
          },
          empty: () => {
            var e, t;
            return (t = (e = this.$slots).empty) === null || t === void 0 ? void 0 : t.call(e);
          }
        });
      }
    };
    return m(P, Object.assign({}, f(this.$props, d), a, {
      internalDeactivateImmediately: !0
    }), {
      trigger: () => {
        var s, r;
        return (r = (s = this.$slots).default) === null || r === void 0 ? void 0 : r.call(s);
      }
    });
  }
});
export {
  E as default,
  w as popselectProps
};
